import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const createImage = ({
    _id,
    origFileName,
    fileSize,
    height,
    url,
    width,
    caption,
  }: any) => {
    if (_id && origFileName && fileSize && height && url && width) {
      return {
        tag: 'Image',
        val: {
          image: {
            fileName: origFileName,
            fileSize,
            height,
            origFileName,
            type: 'image',
            url,
            width,
            _id,
          },
          caption: caption || '',
        },
      };
    }
    return false;
  };

  const createVideo = ({
    originalUrl,
    url,
    html,
    thumbnailUrl,
    width,
    height,
  }: any) => {
    if ((originalUrl || url) && html && thumbnailUrl && height && width) {
      return {
        tag: 'Video',
        val: {
          embed: {
            meta: {
              height,
              html,
              thumb: {url: thumbnailUrl},
              url: url || originalUrl,
              width,
            },
            url,
            type: 'video',
          },
        },
      };
    }
    return false;
  };

  const hasItems = data.json?.items && data.json?.items.length > 0;
  const isLightbox = jsonNode.type === 'LightboxWrapper';
  const hasOldItems =
    hasItems &&
    (data.json.items[0].type === 'image' ||
      data.json.items[0].type === 'video');
  const hasGroup = typeof data.json?.group === 'string';

  const needsMigration = isLightbox && (hasOldItems || !hasGroup);

  return {
    needed: needsMigration,
    logData: {
      msg: 'LightboxWrapper data should be converted to Data Type',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // If we don't have items, we can only make sure that the json is well
      // formed and set defaults
      if (!data.json?.items) {
        data.json = {
          items: [],
          group: data.json?.group || '',
        };
        return;
      }

      const newItems = hasOldItems
        ? data.json.items.reduce((acc: Array<any>, item: any) => {
            if (item.type && item.type === 'image') {
              const imageItem = createImage(item);
              if (imageItem) {
                acc.push(imageItem);
              }
            } else if (item.type && item.type === 'video') {
              const videoItem = createVideo(item);
              videoItem && acc.push(videoItem);
            }
            return acc;
          }, [])
        : data.json.items;

      data.json.items = [...newItems];
      if (!data.json.group) data.json.group = '';
    },
  };
};
